export var ContextGLVertexBufferFormat;
(function (ContextGLVertexBufferFormat) {
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["FLOAT_1"] = 0] = "FLOAT_1";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["FLOAT_2"] = 1] = "FLOAT_2";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["FLOAT_3"] = 2] = "FLOAT_3";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["FLOAT_4"] = 3] = "FLOAT_4";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["BYTE_1"] = 4] = "BYTE_1";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["BYTE_2"] = 5] = "BYTE_2";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["BYTE_3"] = 6] = "BYTE_3";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["BYTE_4"] = 7] = "BYTE_4";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_BYTE_1"] = 8] = "UNSIGNED_BYTE_1";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_BYTE_2"] = 9] = "UNSIGNED_BYTE_2";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_BYTE_3"] = 10] = "UNSIGNED_BYTE_3";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_BYTE_4"] = 11] = "UNSIGNED_BYTE_4";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["SHORT_1"] = 12] = "SHORT_1";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["SHORT_2"] = 13] = "SHORT_2";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["SHORT_3"] = 14] = "SHORT_3";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["SHORT_4"] = 15] = "SHORT_4";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_SHORT_1"] = 16] = "UNSIGNED_SHORT_1";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_SHORT_2"] = 17] = "UNSIGNED_SHORT_2";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_SHORT_3"] = 18] = "UNSIGNED_SHORT_3";
    ContextGLVertexBufferFormat[ContextGLVertexBufferFormat["UNSIGNED_SHORT_4"] = 19] = "UNSIGNED_SHORT_4";
})(ContextGLVertexBufferFormat || (ContextGLVertexBufferFormat = {}));



// WEBPACK FOOTER //
// ../dist/lib/base/ContextGLVertexBufferFormat.js